import axiosInstance from '../axios/axiosInstance';

export interface UsageStatistics {
  overview: {
    totalOrganizations: number;
    paidOrganizations: number;
    freeOrganizations: number;
    totalUsers: number;
    totalWorkspaces: number;
    totalProjects: number;
    activeProjects: number;
  };
  conversations: {
    total: number;
    completed: number;
    inProgress: number;
    abandoned: number;
    completionRate: string;
    avgPerProject: number;
  };
  recentActivity: {
    newOrganizationsLast7Days: number;
    newProjectsLast7Days: number;
    newConversationsLast7Days: number;
    completedConversationsLast7Days: number;
  };
  latestOrganizations: Array<{
    _id: string;
    name: string;
    subscribed: boolean;
    memberCount: number;
    ownerEmail: string;
    createdAt: string;
  }>;
  latestProjects: Array<{
    _id: string;
    title: string;
    status: string;
    organizationName: string;
    respondentsCount: number;
    respondentsMax: number;
    createdAt: string;
  }>;
}

export const statisticsApi = {
  /**
   * Get usage statistics across the platform
   */
  getUsage: async (): Promise<UsageStatistics> => {
    const { data } = await axiosInstance.get<UsageStatistics>('/statistics/usage');
    return data;
  },
};
